import styles from './Button.module.scss';
import cn from "classnames";
import 'animate.css';
import {useEffect} from "react";

export const Button = ({text, type = "active", handler, className, ...props}) => {
    const animateCSS = (element, animation, prefix = 'animate__') =>
        new Promise((resolve, reject) => {
            const animationName = `${prefix}${animation}`;
            const node = document.querySelector(element);

            node && node.classList.add(`${prefix}animated`, animationName);

            function handleAnimationEnd(event) {
                event.stopPropagation();
                node.classList.remove(`${prefix}animated`, animationName);
                resolve('Animation ended');
            }

            node && node.addEventListener('animationend', handleAnimationEnd, {once: true});
        });

    useEffect(() => {
        const interval = setInterval(() => {
            animateCSS('.animation', 'pulse');
        }, 3000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div onClick={handler} className={cn(styles.button, styles[type], type === 'active' ? 'animation' : '', className ? className : '')} {...props}>
            <div className={styles.text}><span>{text}</span></div>
        </div>
    )
}